import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FileCabinetFormsService } from "./file-cabinet.service";
import { MatTableDataSource } from '@angular/material/table';
import * as _ from 'lodash';
import { S3Service } from '../services/s3.service';
import { Router } from '@angular/router';
import { DashboardService } from '../dashboard/dashboard.service';
import { SharedService } from '../services/shared.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SelectionModel } from '@angular/cdk/collections';
import { environment } from 'src/environments/environment';
import * as moment from 'moment-timezone';
import { MatSort } from '@angular/material/sort';
import { FilterService } from '../services/filter.service';

export interface PeriodicElement {
	name: string;
	sortTime: string;
	sortSenders: string;
	sortForms: string;
	sortTopics: string;
	subTopics: string;
}
@Component({
	selector: 'app-file-cabinet',
	templateUrl: './file-cabinet.component.html',
	styleUrls: ['./file-cabinet.component.scss']
})
export class FileCabinetComponent implements OnInit {

	@ViewChild(MatSort) sort: MatSort;

	sortForms = ["All Forms"];
	displayNoRecords: boolean = false;
	displayedColumns = [
		"select",
		"sortTopics",
		"subTopics",
		"name",
		"sortSenders",
		"sortForms",
		"sortTime",
		"star",
	];
	fileCabinetForms: any = [];
	bgTextColor = "#000000";
	sortTopics = ["All Topics"];
	sortSubTopics = ["All Sub Topics"];
	sortSenders = ["All Senders"];
	filteredTopic = "";
	filteredSubtopic = "";
	filteredSender = "";
	filteredForm = ""
	tableDataSource = [];
	formsChecked: boolean = false;
	formsToDrag = [];
	selection = new SelectionModel<PeriodicElement>(true, []);
	yellow_cricle = { "v": "5.6.5", "fr": 60, "ip": 0, "op": 30, "w": 1500, "h": 1500, "nm": "3", "ddd": 0, "assets": [{ "id": "comp_0", "layers": [{ "ddd": 0, "ind": 1, "ty": 4, "nm": "mask_Shape_gray 2", "td": 1, "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [776, 752, 0], "ix": 2 }, "a": { "a": 0, "k": [26, 2, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "a": 0, "k": [1412, 1412], "ix": 2 }, "p": { "a": 0, "k": [0, 0], "ix": 3 }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 0, "ix": 5 }, "lc": 1, "lj": 1, "ml": 4, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [0.322952719296, 0.338910450655, 0.549019607843, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 4], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 601, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "orange_moving", "tt": 1, "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 1, "k": [{ "i": { "x": 0.273, "y": 1 }, "o": { "x": 0.589, "y": 0 }, "t": 38, "s": [2727.669, 2320.391, 0], "to": [-1707.16, -378.773, 0], "ti": [0, 0, 0] }, { "t": 195, "s": [-58.171, 766.231, 0] }], "ix": 2 }, "a": { "a": 0, "k": [0, 180, 0], "ix": 1 }, "s": { "a": 0, "k": [434.46, 268, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [-19.56, 7.86], [-20.16, -6.12], [-17.22, -9.78], [-9.36, -3.12], [-9.84, 0.78], [-8.94, 4.26], [-8.4, 5.22], [-9.06, 3.84], [-9.9, -0.18], [-9, -4.14], [-8.34, -5.28], [-9, -4.08], [-9.9, 0], [-9, 4.02], [-8.34, 5.28], [-9, 4.14], [-9.9, 0.18], [-9.06, -3.84], [-8.4, -5.16], [-8.88, -4.32], [-9.84, -0.78], [-9.42, 3.12], [-8.58, 4.86], [-18.96, 5.7], [-19.56, -7.8], [-10.44, -18.36], [0, 0], [0, 0]], "o": [[10.38, -18.36], [19.56, -7.8], [18.96, 5.7], [8.58, 4.86], [9.42, 3.12], [9.9, -0.78], [8.88, -4.32], [8.4, -5.16], [9.12, -3.84], [9.84, 0.18], [8.94, 4.14], [8.34, 5.28], [9.06, 4.02], [9.9, 0], [9.06, -4.08], [8.34, -5.28], [9, -4.14], [9.9, -0.18], [9.12, 3.84], [8.34, 5.22], [8.88, 4.26], [9.9, 0.78], [9.36, -3.12], [17.16, -9.78], [20.16, -6.12], [19.56, 7.86], [0, 0], [0, 0], [0, 0]], "v": [[-434.7, -96.808], [-387.96, -137.608], [-326.04, -140.308], [-273.36, -113.369], [-246.54, -100.889], [-217.38, -96.808], [-189.06, -105.088], [-163.44, -119.969], [-137.46, -134.128], [-108.66, -140.308], [-80.1, -133.048], [-54.42, -118.288], [-28.68, -103.648], [0, -96.808], [28.62, -103.648], [54.42, -118.288], [80.1, -133.048], [108.66, -140.308], [137.4, -134.128], [163.44, -119.969], [189.06, -105.088], [217.32, -96.808], [246.54, -100.889], [273.36, -113.369], [326.04, -140.308], [387.96, -137.608], [434.7, -96.808], [434.7, 504.272], [-434.7, 504.272]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [0.937254961799, 0.658823529412, 0.352941176471, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 602, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "mask_Shape_gray 3", "td": 1, "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [776, 752, 0], "ix": 2 }, "a": { "a": 0, "k": [26, 2, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "a": 0, "k": [1412, 1412], "ix": 2 }, "p": { "a": 0, "k": [0, 0], "ix": 3 }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 0, "ix": 5 }, "lc": 1, "lj": 1, "ml": 4, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [0.322952719296, 0.338910450655, 0.549019607843, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 4], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 601, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "blue_moving 2", "tt": 1, "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 1, "k": [{ "i": { "x": 0.273, "y": 1 }, "o": { "x": 0.589, "y": 0 }, "t": 38, "s": [-1352.331, 2232.391, 0], "to": [1724.84, -450.773, 0], "ti": [0, 0, 0] }, { "t": 195, "s": [1589.829, 758.231, 0] }], "ix": 2 }, "a": { "a": 0, "k": [0, 180, 0], "ix": 1 }, "s": { "a": 0, "k": [434.46, 268, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [-19.56, 7.86], [-20.16, -6.12], [-17.22, -9.78], [-9.36, -3.12], [-9.84, 0.78], [-8.94, 4.26], [-8.4, 5.22], [-9.06, 3.84], [-9.9, -0.18], [-9, -4.14], [-8.34, -5.28], [-9, -4.08], [-9.9, 0], [-9, 4.02], [-8.34, 5.28], [-9, 4.14], [-9.9, 0.18], [-9.06, -3.84], [-8.4, -5.16], [-8.88, -4.32], [-9.84, -0.78], [-9.42, 3.12], [-8.58, 4.86], [-18.96, 5.7], [-19.56, -7.8], [-10.44, -18.36], [0, 0], [0, 0]], "o": [[10.38, -18.36], [19.56, -7.8], [18.96, 5.7], [8.58, 4.86], [9.42, 3.12], [9.9, -0.78], [8.88, -4.32], [8.4, -5.16], [9.12, -3.84], [9.84, 0.18], [8.94, 4.14], [8.34, 5.28], [9.06, 4.02], [9.9, 0], [9.06, -4.08], [8.34, -5.28], [9, -4.14], [9.9, -0.18], [9.12, 3.84], [8.34, 5.22], [8.88, 4.26], [9.9, 0.78], [9.36, -3.12], [17.16, -9.78], [20.16, -6.12], [19.56, 7.86], [0, 0], [0, 0], [0, 0]], "v": [[-434.7, -96.808], [-387.96, -137.608], [-326.04, -140.308], [-273.36, -113.369], [-246.54, -100.889], [-217.38, -96.808], [-189.06, -105.088], [-163.44, -119.969], [-137.46, -134.128], [-108.66, -140.308], [-80.1, -133.048], [-54.42, -118.288], [-28.68, -103.648], [0, -96.808], [28.62, -103.648], [54.42, -118.288], [80.1, -133.048], [108.66, -140.308], [137.4, -134.128], [163.44, -119.969], [189.06, -105.088], [217.32, -96.808], [246.54, -100.889], [273.36, -113.369], [326.04, -140.308], [387.96, -137.608], [434.7, -96.808], [434.7, 504.272], [-434.7, 504.272]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [0.160784313725, 0.462745098039, 0.713725490196, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 602, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 5, "ty": 4, "nm": "Shape_gray", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [776, 752, 0], "ix": 2 }, "a": { "a": 0, "k": [26, 2, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "a": 0, "k": [1412, 1412], "ix": 2 }, "p": { "a": 0, "k": [0, 0], "ix": 3 }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 0, "ix": 5 }, "lc": 1, "lj": 1, "ml": 4, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [0.945098039216, 0.937254901961, 0.937254901961, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 4], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 601, "st": 0, "bm": 0 }] }], "layers": [{ "ddd": 0, "ind": 1, "ty": 0, "nm": "option_2", "refId": "comp_0", "sr": 0.26, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [750, 750, 0], "ix": 2 }, "a": { "a": 0, "k": [750, 750, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "w": 1500, "h": 1500, "ip": 0, "op": 31, "st": -13.7703703703704, "bm": 0 }], "markers": [] }
	flaggedFilter = false;
	timezone;
	constructor(
		private _fileCabinetFormsService: FileCabinetFormsService,
		private _s3Service: S3Service,
		private _router: Router,
		private _dashboardService: DashboardService,
		private _sharedService: SharedService,
		private _snackBar: MatSnackBar,
		private _changeDetectionRef: ChangeDetectorRef,
		private _filterService: FilterService
	) {
		this._sharedService.searchChange.subscribe((value) => {
			this.fileCabinetForms.filter = value.toLowerCase();
			if (this.fileCabinetForms.filteredData.length === 0) {
				this.displayNoRecords = true;
			} else {
				this.displayNoRecords = false;
			}
			this.updateFiltersForSearch();
		});

		this._fileCabinetFormsService.updatedFormsEvent.subscribe(forms => {
			this.refreshFormsList(forms);
		});
	}

	ngOnInit(): void {
		this.timezone = localStorage.getItem('timezone')
		this.onInit();
	}

	ngAfterViewChecked() {
		if (this.check(this.bgTextColor)) {
			this._sharedService.updateHomeColor(this.bgTextColor);
		}
	}

	check(hex) {
		if (/[0-9A-F]{6}$/i.test(hex)) {
			return true;
		}
	}

	onInit(): void {
		let searchInput = document.getElementById("searchInput");
		if (localStorage.getItem("bgTextColor"))
			this.bgTextColor = localStorage.getItem("bgTextColor");
		this.sortTopics = ["All Topics"];
		this.sortSubTopics = ["All Sub Topics"];
		this.sortSenders = ["All Senders"];
		this.sortForms = ["All Forms"];
		this.filteredTopic = "";
		this.filteredSubtopic = "";
		this.filteredSender = "";
		this.filteredForm = "";
		searchInput["value"] = "";
		this.displayNoRecords = false;
		this.fileCabinetForms = [];
		this._fileCabinetFormsService
			.getFileCabinetForms(localStorage.getItem("organization"), localStorage.getItem("defaultAction"))
			.subscribe(
				(response) => {
					if (response["success"]) {
						if (response["data"] && response["data"]["documents"] && response["data"]["documents"].length > 0) {
							let fileCabinetForms = response["data"]["documents"];
							if (fileCabinetForms.length > 0) {
								fileCabinetForms.forEach((form) => {
									// console.log("Form name ", form.sortForms)
									form["checked"] = false;
									form["sortTopics"] = form["sortTopics"]
										? _.isString(form["sortTopics"])
											? form["sortTopics"]
											: Object.values(form["sortTopics"])[0]
										: "";
									form["subTopics"] = form["subTopics"]
										? _.isString(form["subTopics"])
											? form["subTopics"]
											: Object.values(form["subTopics"])[0]
										: "";

									if (!_.includes(this.sortTopics, form["sortTopics"])) {
										if (form["sortTopics"] && form["sortTopics"].length !== 0) {
											this.sortTopics.push(form["sortTopics"]);
										}
									}

									if (!_.includes(this.sortSubTopics, form["subTopics"])) {
										if (form["subTopics"] && form["subTopics"].length !== 0) {
											this.sortSubTopics.push(form["subTopics"]);
										}
									}

									if (!_.includes(this.sortSenders, form["sortSenders"])) {
										if (form["sortSenders"] && form["sortSenders"].length !== 0) {
											this.sortSenders.push(form["sortSenders"]);
										}
									}

									if (!_.includes(this.sortForms, form.sortForms)) {
										if (form["sortForms"] && form["sortForms"].length !== 0) {
											this.sortForms.push(form["sortForms"])
										}
									}

									if (this.timezone) {
										form['sortTime'] = moment(form['sortTime']).tz(this.timezone).format('llll')
									}

								});
								this.sortFilters()
								this.fileCabinetForms = new MatTableDataSource(fileCabinetForms);
								this.fileCabinetForms.sort = this.sort;
								this._fileCabinetFormsService.refreshCount([]);
								this.tableDataSource = fileCabinetForms;
							}
						}
					}
					this.sortFilters()
				},
				(error) => {
					console.log(error);
				}
			);
	}

	getFormDetails(formId) {
		this._router.navigateByUrl("/formDetails/FileCabinet/" + formId);
	}

	deleteSubmittedForm(formId) {
		// this._sharedService.confirmationDialog(
		//   "This action will move the form to Trash",
		//   () => {
		let requestData = {
			formId: formId,
		};

		this._dashboardService.deleteSubmittedForm(requestData).subscribe(
			(response) => {
				if (response["success"]) {
					this.fileCabinetForms = [];
					this.onInit();
				}
			},
			(error) => {
				console.log(error);
			}
		);
		//   }
		// );
	}

	restoreIntoHome(restoredForm) {
		let requestData = {
			data: [],
			actionTypeId: localStorage.getItem("defaultAction")
		}
		this.fileCabinetForms.data.forEach((row) => {
			if (restoredForm != row._id) {
				let obj = {
					id: row._id
				}
				requestData.data.push(obj);
			}
		})
		this._dashboardService.deleteFormInActionType(requestData).subscribe((response) => {
			if (response["success"]) {
				this.openSnackBar("File Cabinet List Updated successfully");
				this.onInit();
			} else {
				this.openSnackBar("File Cabinet List Updating failed");
			}
		}, (error) => {
			console.log(error);
			this.openSnackBar(error["message"]);
		});
	}

	restoreArchivedForm(formId) {
		this._sharedService.confirmationDialog(
			"Are you sure you want to remove this form?",
			() => {
				let requestData = {
					formIds: [formId],
				};

				this._fileCabinetFormsService.restoreFileCabinetForms(requestData).subscribe(
					(response) => {
						this.openSnackBar(response["message"]);
						this.onInit();
					},
					(error) => {
						console.log(error);
						this.openSnackBar("Server side error occurred");
					}
				);
			}
		);
	}

	openSnackBar(message) {
		this._snackBar.open(message, "Ok", {
			duration: 2000,
		});
	}

	onReloadClick(): void {
		this.onInit();
	}

	filterTopics(value): void {
		if (value === "All Topics") {
			this.filteredTopic = "";
		} else {
			this.filteredTopic = value;
		}

		this.applyFilters();
	}

	filterSubTopics(value): void {
		if (value == "All Sub Topics") {
			this.filteredSubtopic = "";
		} else {
			this.filteredSubtopic = value;
		}
		this.applyFilters();
	}

	filterSenders(value): void {
		if (value == "All Senders") {
			this.filteredSender = "";
		} else {
			this.filteredSender = value;
		}
		this.applyFilters();
	}

	filterForms(value): void {
		if (value == "All Forms") {
			this.filteredForm = "";
		} else {
			this.filteredForm = value;
		}
		this.applyFilters();
	}



	sortFilters() {
		this.sortTopics = this._filterService.sortFilterOptions(this.sortTopics, "All Topics");
		this.sortSubTopics = this._filterService.sortFilterOptions(this.sortSubTopics, "All Sub Topics");
		this.sortSenders = this._filterService.sortFilterOptions(this.sortSenders, "All Senders");
		this.sortForms = this._filterService.sortFilterOptions(this.sortForms, "All Forms");
	}

	resetFilters() {
		this.filteredForm = "";
		this.filteredTopic = "";
		this.filteredSubtopic = "";
		this.filteredSender = "";
	}


	flagSubmittedForm(formId, is_flagged) {
		let requestData = {
			formId: formId
		};

		const index = this.fileCabinetForms._data._value.findIndex(form => form._id === formId)
		if (is_flagged) {
			this.fileCabinetForms._data._value[index]['is_flagged'] = false
			this._dashboardService.unflagSubmittedForm(requestData).subscribe((response) => {
				if (response["success"]) {
					// Nothing
				}
			}, (error) => {
				this.fileCabinetForms._data._value[index]['is_flagged'] = is_flagged;
				this.openSnackBar("Server side error occurred. Please try again");
				console.log(error);
			});
		} else {
			this.fileCabinetForms._data._value[index]['is_flagged'] = true

			this._dashboardService.flagSubmittedForm(requestData).subscribe((response) => {
				if (response["success"]) {
					// Nothing
				}
			}, (error) => {
				this.fileCabinetForms._data._value[index]['is_flagged'] = is_flagged;
				this.openSnackBar("Server side error occurred. Please try again");
				console.log(error);
			});
		}

	}

	onChecked(row, value): void {
		this.formsChecked = true;
		if (value) {
			row.checked = true;
			this.formsToDrag.push(row._id);
		} else {
			row.checked = false;
			let index = this.formsToDrag.indexOf(row._id);
			this.formsToDrag.splice(index, 1);
		}
	}

	checkboxLabel(row?: PeriodicElement): string {
		if (!row) {
			return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
		}
		return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.name + 1}`;
	}

	isAllSelected() {
		const numSelected = this.selection.selected.length;
		let numRows = 0;
		if (this.fileCabinetForms && this.fileCabinetForms.data && this.fileCabinetForms.data.length) {
			numRows = this.fileCabinetForms.data.length;
		}
		return numSelected === numRows;
	}

	onDragStart(event, row?): void {

		if (this.formsToDrag.length == 0) {
			// If only a single form is dragged
			let draggedForms = [row._id]
			var canvas = document.createElement('canvas');
			var context = canvas.getContext('2d');

			canvas.width = 200;
			canvas.height = 40;
			context.fillStyle = '#2d6cff';
			context.font = 'bold 14px Helvetica';
			context.fillRect(0, 0, canvas.width, canvas.height);
			context.fillStyle = '#ffffff';

			context.fillText('Copying ' + 1 + ' submission(s)', 25, 25);
			document.body.append(canvas);
			event.dataTransfer.effectAllowed = 'copy';
			event.dataTransfer.setDragImage(canvas, -15, 9);
			event.dataTransfer.setData(JSON.stringify(draggedForms), "");
			event.dataTransfer.dropEffect = 'move';
			event.dataTransfer.effectAllowed = 'move';
		} else {
			var canvas = document.createElement('canvas');
			var context = canvas.getContext('2d');

			canvas.width = 200;
			canvas.height = 40;
			context.fillStyle = '#2d6cff';
			context.font = 'bold 14px Helvetica';
			context.fillRect(0, 0, canvas.width, canvas.height);
			context.fillStyle = '#ffffff';

			let formsLength = this.formsToDrag.length;
			context.fillText('Copying ' + formsLength + ' submission(s)', 25, 25);
			document.body.append(canvas);
			event.dataTransfer.effectAllowed = 'copy';
			event.dataTransfer.setDragImage(canvas, -15, 9);
			event.dataTransfer.setData(JSON.stringify(this.formsToDrag), "");
			event.dataTransfer.dropEffect = 'move';
			event.dataTransfer.effectAllowed = 'move';
		}
	}

	onDragEnd(): void {
		// this.onInit();
		// this.formsToDrag = []
	}

	updateFormsList(submittedForms) {
		this.sortForms = ["All Forms"];
		this.sortTopics = ["All Topics"];
		this.sortSubTopics = ["All Sub Topics"];
		this.sortSenders = ["All Senders"];
		if (submittedForms && submittedForms.length > 0) {
			submittedForms.forEach((form) => {
				form["checked"] = false;
				form["sortTopics"] = form["sortTopics"] ? (_.isString(form["sortTopics"]) ? form["sortTopics"] : Object.values(form["sortTopics"])[0]) : '';
				form["subTopics"] = form["subTopics"] ? (_.isString(form["subTopics"]) ? form["subTopics"] : Object.values(form["subTopics"])[0]) : '';

				if (!_.includes(this.sortForms, form.sortForms)) {
					this.sortForms.push(form.sortForms);
				}

				if (!_.includes(this.sortTopics, form["sortTopics"])) {
					if (form["sortTopics"].length !== 0) {
						this.sortTopics.push(form["sortTopics"])
					}
				}

				if (!_.includes(this.sortSubTopics, form["subTopics"])) {
					if (form["subTopics"].length !== 0) {
						this.sortSubTopics.push(form["subTopics"])
					}
				}

				if (!_.includes(this.sortSenders, form["sortSenders"])) {
					if (form["sortSenders"] && form["sortSenders"].length !== 0) {
						this.sortSenders.push(form["sortSenders"]);
					}
				}
			});

			this.fileCabinetForms = new MatTableDataSource(submittedForms);
			this.fileCabinetForms.sort = this.sort;
			this.tableDataSource = this.fileCabinetForms;
		} else {
			this.fileCabinetForms = [];
			this.tableDataSource = [];
		}
	}

	refreshFormsList(forms) {
		let fileCabinetForms = this.fileCabinetForms._data._value.filter((form) => {
			return (forms.indexOf(form._id) === -1)
		});
		this.updateFormsList(fileCabinetForms);
	}

	filterFlaggedForms(val) {
		this.flaggedFilter = !this.flaggedFilter;
		this.applyFilters();
	}

	archiveSubmittedForm(formId, template) {
		// this._sharedService.confirmationDialog("Are you sure you want to archive the form?", () => {
		let requestData = {
			formId: formId,
			template: template
		};

		if (template == environment.help_form_id) {
			requestData['updated_by'] = {
				username: localStorage.getItem('username'),
				user_id: localStorage.getItem('userId'),
				organization_id: localStorage.getItem('organization')
			}
		}

		this._dashboardService.archiveSubmittedForm(requestData).subscribe((response) => {
			if (response["success"]) {
				this.openSnackBar("Form archived successfully");
				let submittedForms = this.fileCabinetForms._data._value;
				let formIndex = submittedForms.findIndex((form) => form._id === formId);
				submittedForms.splice(formIndex, 1);
				this.updateFormsList(submittedForms);
			}
		}, (error) => {
			console.log(error);
		});
		// });
	}

	// Check if any filter is active
	hasActiveFilters(): boolean {
		return this._filterService.hasActiveFilters({
			topic: this.filteredTopic,
			subtopic: this.filteredSubtopic,
			sender: this.filteredSender,
			form: this.filteredForm
		});
	}

	// Clear individual filter
	clearFilter(type: string) {
		switch (type) {
			case 'topic':
				this.filteredTopic = "";
				break;
			case 'subtopic':
				this.filteredSubtopic = "";
				break;
			case 'sender':
				this.filteredSender = "";
				break;
			case 'form':
				this.filteredForm = "";
				break;
		}
		this.applyFilters();
	}

	// Apply all active filters
	applyFilters() {
		const filters = {
			topic: this.filteredTopic,
			subtopic: this.filteredSubtopic,
			sender: this.filteredSender,
			form: this.filteredForm
		};

		const filteredData = this._filterService.applyFilters(this.tableDataSource, filters, this.flaggedFilter);

		this.fileCabinetForms = new MatTableDataSource(filteredData);
		this.fileCabinetForms.sort = this.sort;
		this._changeDetectionRef.detectChanges();
		this.updateFilterLists();
		this.sortFilters();
	}

	// Dynamic update of dropdown lists based on active filters (faceted search)
	updateFilterLists() {
		const filters = {
			topic: this.filteredTopic,
			subtopic: this.filteredSubtopic,
			sender: this.filteredSender,
			form: this.filteredForm
		};

		const options = this._filterService.getFilterOptions(this.tableDataSource, filters);
		this.sortTopics = options.topics;
		this.sortSubTopics = options.subTopics;
		this.sortSenders = options.senders;
		this.sortForms = options.forms;
	}

	// Update filters based on search results
	updateFiltersForSearch() {
		const searchText = this._sharedService.searchText;
		const options = this._filterService.updateFiltersForSearch(this.fileCabinetForms, searchText);
		this.sortTopics = options.topics;
		this.sortSubTopics = options.subTopics;
		this.sortSenders = options.senders;
		this.sortForms = options.forms;
		this.sortFilters();
	}
}
